import style from "./SignedDocument.module.css";
// * Components
import ContinueButton from "../../Buttons/SlideContinueButton/ContinueButton";

export default function SignedDocument({
  title,
  documentType,
  document,
  switchToNextSlide,
  updateLastVisitSlide,
  loading,
}) {
  const continueToNextSlide = () => {
    let slidePayload = {};
    if (documentType === "sanctionLetter") {
      slidePayload.slideName = "Signed Sanction Letter";
      slidePayload.slideIcon = "SignedSanctionLetter";
      // slidePayload.slideIndex = 31;
    } else if (documentType === "agreement") {
      slidePayload.slideName = "Signed Agreement";
      slidePayload.slideIcon = "SignedAgreement";
      // slidePayload.slideIndex = 34;
    }
    updateLastVisitSlide(slidePayload);

    switchToNextSlide();
  };

  return (
    <div className={style.slide}>
      <div className={style.slideHeader}>
        <h1>{title && title}</h1>
      </div>

      <div className={style.slideBody}>
        <div className={style.documentPreview}>
          {document ? (
            <iframe src={document} className={style.previewDoc} />
          ) : null}
        </div>
      </div>

      <div className={style.slideFooter}>
        <ContinueButton
          loading={loading ? loading : false}
          handler={continueToNextSlide}
        />
      </div>
    </div>
  );
}
